import { createMutationHook } from '~/shared/providers/api';

export const useUpdateFacilityGroupMutation = createMutationHook(
  'facilities.facilityGroupUpdate',
  (params: { id: string; name: string; facilityIds?: string[] }) => ({
    coreFacilityGroupUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          facilityIds: params.facilityIds,
        },
      },
      id: true,
      name: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
